import { ErrorMessage, Field, useFormikContext } from "formik";
import { SealRegistrationFormData } from "../SealRegistrationContext";

export const RegisteredVineyardsSection = () => {
  const { values, setFieldValue } = useFormikContext<SealRegistrationFormData>();

  const addVineyardUrl = () => {
    setFieldValue("vineyardUrls", [...values.vineyardUrls, { value: "" }]);
  };

  const removeVineyardUrl = (index: number) => {
    const updated = values.vineyardUrls.filter((_, i) => i !== index);
    setFieldValue("vineyardUrls", updated);
  };

  return (
    <div className="seal-form-section seal-form-section--bordered">
      <h2 className="sub-headline">Registered vineyards</h2>
      <p className="description-text">
        Provide at least one Old Vine Registry vineyard page associated with your
        intended use of the seal. OVR will review the submitted vineyard
        information before confirming your registration.
      </p>

      {values.vineyardUrls.map((_, index) => (
        <div key={index} className="seal-vineyard-row">
          <label className="form-label">OVR vineyard page URL *</label>
          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            <Field name={`vineyardUrls.${index}.value`}>
              {({ field, meta }) => (
                <input
                  {...field}
                  type="text"
                  placeholder="https://www.oldvineregistry.org/vineyard/..."
                  autoComplete="off"
                  className={`input-text seal-vineyard-input ${
                    meta.error && meta.touched ? "input-field-error" : ""
                  }`}
                />
              )}
            </Field>
            {values.vineyardUrls.length > 1 && (
              <button
                type="button"
                onClick={() => removeVineyardUrl(index)}
                className="seal-vineyard-remove-button"
              >
                Remove
              </button>
            )}
          </div>
        </div>
      ))}

      <ErrorMessage
        name="vineyardUrls"
        className="input-error"
        component="span"
      />

      <div style={{ display: "flex", alignItems: "center", gap: "20px", marginTop: "16px", flexWrap: "wrap" }}>
        <button
          type="button"
          onClick={addVineyardUrl}
          className="seal-add-vineyard-button"
        >
          + Add another vineyard
        </button>
        <a href="/" className="description-sub-text-link">
          Search for a vineyard in the OVR
        </a>
      </div>

      <p className="form-fields-sub-text" style={{ marginTop: "20px" }}>
        Vineyard review and registration confirmation may take 1–3 weeks. OVR may
        contact you if additional information is needed.
      </p>
      <p className="form-fields-sub-text">
        Don't see the vineyard you need?{" "}
        <a href="/submit" className="form-fields-sub-text-link">
          Submit it to the Old Vine Registry
        </a>{" "}
        before completing this registration.
      </p>

      <div className="field-spacing">
        <label className="form-label">
          Example wines on which you expect to use the seal (optional)
        </label>
        <Field
          name="wineNotes"
          as="textarea"
          rows={3}
          autoComplete="off"
          className="input-text"
          style={{ width: "100%" }}
        />
        <span className="form-fields-sub-text">
          This information helps OVR understand anticipated program use.
          Individual wines and vintages are not separately registered or approved.
        </span>
      </div>
    </div>
  );
};
